import { roleContentFromJson, signUpContentFromJson } from 'cloud-frontend'

import { LocalResolver } from '@sketch/gql-types/resolvers'
import { getNetworkRequestHeaders } from '@sketch/modules-common'

const HEADERS = {
  ...getNetworkRequestHeaders(),
  'Content-Type': 'application/json',
}

export const campaignSignUpContent: LocalResolver<'Query'>['campaignSignUpContent'] = async (
  _,
  { campaign }
) => {
  const response = await fetch(`/data/signup/campaign/${campaign}.json`, {
    headers: HEADERS,
  })

  if (response.status === 200) {
    const json = await response.json()

    return {
      __typename: 'CampaignSignUpContent',
      active: json.active ?? true,
      content: signUpContentFromJson(json),
    }
  }

  return null
}

export const roleSignUpContent: LocalResolver<'Query'>['roleSignUpContent'] = async () => {
  const response = await fetch('/data/signup/roles.json', {
    headers: HEADERS,
  })

  if (response.status === 200) {
    const json = await response.json()

    return roleContentFromJson(json)
  }

  throw new Error('Something went wrong')
}
